/** Deterministic “stock” portrait per candidate id (Picsum seed). */
export function candidatePortraitUrl(candidateId: string, size = 48): string {
  const seed = encodeURIComponent(candidateId.replace(/-/g, '').slice(0, 16));
  return `https://picsum.photos/seed/${seed}/${size}/${size}`;
}
